import { Component, OnInit } from '@angular/core';
import { DetailsBaseComponent } from '../../../../../../core/base/components/details-base/details-base.component';
import { ENUM_PERMISSIONS } from '../../../../../../core/enums/permission.enum';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '../../../../../../core/services/auth.service';
import { EstablishmentModel } from '../../../../../../core/models/establishment.model';
import icAdd from '@iconify/icons-ic/twotone-add';
import { EstablishmentService } from '../../establishment.service';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { EstablishmentNeedsSelectModalComponent } from '../../modals/establishment-needs-select/establishment-needs-select.component';
import { CrudModeEnum } from '../../../../../../core/base/enum/crud-mode.enum';
import { take } from 'rxjs/operators';
import { DataTableBase } from '../../../../../../core/base/components/data-table-base/data-table-base';
import { Subscription } from 'rxjs';

@Component({
  selector: 'vex-establishment-details-needs',
  templateUrl: './establishment-details-needs.component.html',
  styleUrls: ['./establishment-details-needs.component.scss'],
})
export class EstablishmentDetailsNeedsComponent implements OnInit {
  readonly icAdd = icAdd;
  ENUM_PERMISSIONS = ENUM_PERMISSIONS;
  entityName = 'Familles achats couvertes';
  displayPostePercentWarning = false;
  establishmentId: any;
  establishment: EstablishmentModel;
  init = false;

  defaultTabs = [
    {
      label: 'Articles',
      route: './',
      routerLinkActiveOptions: { exact: true },
      permission: ENUM_PERMISSIONS.READ_ESTABLISHMENT_NEEDS,
      index: 1,
    },
    {
      label: 'Prestations',
      route: './prestations',
      permission: ENUM_PERMISSIONS.READ_ESTABLISHMENT_NEEDS,
      index: 2,
    },
  ];

  subscription = new Subscription();
  loading = false;

  constructor(
    public authService: AuthService,
    public service: EstablishmentService,
    public dialog: MatDialog,
  ) {}

  ngOnInit() {
    this.initData();
    this.init = false;
  }

  initData() {
    this.loading = true;
    const item = this.service.entity$.subscribe(entity => {
      this.establishment = entity;
      this.loading = false;
    });
    this.subscription.add(item);
  }

  getTitleTip(label: string): string {
    const singular = this.singularize(label.toLowerCase());
    const isFeminine = this.isFeminineWord(singular);
    const article = isFeminine ? 'une' : 'un';
    return `Ajouter ${article} ${singular} générique`;
  }

  private isFeminineWord(word: string): boolean {
    const feminineWords = ['prestation'];
    return feminineWords.includes(word);
  }

  private singularize(word: string): string {
    if (word.endsWith('aux')) {
      return word.slice(0, -3) + 'al';
    }
    if (word.endsWith('s')) {
      return word.slice(0, -1);
    }
    return word;
  }

  async addGenerics(label: string) {
    const isGenericPrestation = label.toLowerCase() === 'prestations';
    const establishment = await this.service.entity;
    this.dialog
      .open(EstablishmentNeedsSelectModalComponent, {
        data: {
          defaults: establishment,
          isGenericPrestation,
          mode: CrudModeEnum.Create,
          title: this.getTitleTip(label),
        },
        width: '500px',
      })
      .afterClosed()
      .subscribe((data: any) => {
        if (data) {
          this.initData();
        }
      });
  }
}
